import { render, staticRenderFns } from "./RegDaan.vue?vue&type=template&id=514f4b9e&scoped=true"
import script from "./RegDaan.vue?vue&type=script&lang=js"
export * from "./RegDaan.vue?vue&type=script&lang=js"
import style0 from "./RegDaan.vue?vue&type=style&index=0&id=514f4b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f4b9e",
  null
  
)

export default component.exports